/**
 * Scrolls the nearest scrollable ancestor so that the element is at the top of the container.
 * Falls back to scrollIntoView if no scrollable ancestor is found.
 */
export const scrollToElement = (element: HTMLElement) => {
  let parent = element.parentElement;
  while (parent && parent.scrollHeight <= parent.clientHeight) {
    parent = parent.parentElement;
  }
  if (parent) {
    const offset = element.getBoundingClientRect().top - parent.getBoundingClientRect().top;
    parent.scrollTo({ top: parent.scrollTop + offset, behavior: "smooth" });
  } else {
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
